// Стили для кнопок
export const buttonStyles =
    "text-sm font-semibold px-3 py-2 rounded-md text-blue-444 dark:text-blue-300 hover:bg-blue-555 dark:hover:bg-gray-555 transition-colors";
export const primaryButtonStyles =
    "text-sm font-medium px-3 py-1.5 rounded-lg bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-500 text-white transition-colors";
export const redButtonStyles =
    "text-sm font-semibold px-3 py-2 rounded-md text-red-500 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/10 transition-colors";

// Стили для инпутов
export const inputStyles =
    "w-full px-3 py-2 mb-3 border rounded-lg bg-white/50 dark:bg-gray-700/80 dark:border-gray-600 text-gray-900 dark:text-white focus:outline-none focus:border-blue-400 dark:focus:border-blue-600 transition";

// Стили для модальных окон
export const modalOverlayStyles =
    "fixed inset-0 bg-black/60 dark:bg-black/60 backdrop-blur-sm z-[9998]";
export const modalContainerStyles =
    "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 pb-3 w-80 z-[9999] border border-gray-300 dark:border-gray-700 transition-all";
export const modalHeaderStyles =
    "mb-4 text-lg font-semibold text-gray-900 dark:text-gray-200";

// Стили для спинера
export const spinnerContainer =
    "flex items-center justify-center h-64";
export const spinnerSvg =
    "animate-spin h-10 w-10 text-blue-500";

// Стили для кнопок с иконками
export const iconButtonStyles =
    "p-1 text-gray-400 dark:text-blue-600 hover:text-gray-500 dark:hover:text-white transition-colors";

export const floatingActionButtonStyles =
    "fixed bottom-6 right-6 w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-colors z-30 " +
    "bg-white text-blue-500 hover:bg-gray-200 " +
    "dark:text-blue-600 dark:bg-gray-900 dark:hover:text-white";

// Стили для боковой панели
export const sidebarContainer =
    "fixed left-0 top-[72px] w-[80px] min-w-[80px] max-w-[80px] h-[calc(100%-160px)] bg-blue-700 dark:bg-gray-900 flex flex-col justify-between transition-colors z-[100]";
export const sidebarButtonBase =
    "w-full h-14 flex items-center justify-center transition-colors";
export const activeButton =
    "bg-gray-700 dark:bg-gray-555 text-blue-400 dark:text-blue-400";
export const inactiveButton =
    "bg-blue-700 dark:bg-gray-900 text-blue-500 dark:text-blue-600 dark:hover:bg-gray-555 hover:text-blue-400 dark:hover:text-blue-400";
export const languageButton =
    "dark:hover:bg-gray-600 hover:bg-blue-600 p-2 bg-blue-700 dark:bg-gray-700 rounded text-gray-900 dark:text-white mb-4 flex items-center justify-center transition-colors";

// Стили для меню боковой панели
export const sidebarMenuOverlay =
    "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-[99998]";
export const sidebarMenuContainer =
    "fixed top-0 left-0 h-full w-64 bg-white/80 dark:bg-gray-800/90 backdrop-blur-lg p-0 z-[99999] transform transition-transform duration-300 ease-in-out text-black dark:text-white";
export const menuItemButton =
    "w-full flex items-center gap-4 text-inherit text-left py-4 px-6 transition-colors hover:bg-gray-100 dark:hover:bg-gray-600";
export const darkModeSwitchContainer =
    "flex items-center justify-between text-inherit py-4 px-6 transition-colors hover:bg-gray-100 dark:hover:bg-gray-600";

// Стили для сортировки
export const sortModalOverlayStyles =
    "fixed inset-0 bg-black/60 dark:bg-black/60 backdrop-blur-sm z-[9998]";
export const sortModalContainerStyles =
    "fixed bottom-0 left-0 right-0 z-[9999] bg-white/85 dark:bg-gray-800/90 text-black dark:text-white p-4 rounded-t-lg w-full transition-transform duration-300 ease-in-out";
export const sortModalItemStyles = (selected) =>
    `p-2 rounded cursor-pointer ${selected
        ? "bg-blue-400 dark:bg-gray-700 text-white dark:text-blue-400"
        : "hover:bg-blue-400 hover:text-white dark:hover:bg-gray-700"}`;
export const sortModalHeaderStyles =
    "mb-4 text-lg font-semibold";

export const modalContentStyles = `fixed left-1/2 top-[30px] transform -translate-x-1/2 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 w-[350px] md:w-[450px] z-[9999] border border-gray-300 dark:border-gray-700 transition-all
[@media(max-width:400px)]:w-[calc(100vw-20px)] [@media(max-width:400px)]:max-w-[calc(100vw-20px)]`;

export const addPostcardModalStyles = "fixed left-1/2 top-[30px] transform -translate-x-1/2 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 w-[350px] sm:w-[500px] z-[9999] border border-gray-300 dark:border-gray-700 transition-all";

export const fullscreenModalStyles = "fixed inset-0 bg-white dark:bg-gray-800 z-[9999] transition-all sm:left-1/2 sm:top-[30px] sm:transform sm:-translate-x-1/2 sm:rounded-lg sm:shadow-lg sm:p-4 sm:w-[500px] sm:h-auto sm:inset-auto";

export const authModalStyles = "fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 w-[350px] z-[9999] border border-gray-300 dark:border-gray-700 transition-all";

// Стили для ChannelOptionsMenu
export const channelOptionsMenuWrapper = "absolute right-0";
export const channelOptionsMenuContainer =
    "absolute right-0 py-2 mt-2 w-auto min-w-[120px] origin-top-right bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-900 rounded shadow-lg z-[9999]";

// Новые стили для CommonMenu
export const channelOptionsMenuItemButton =
    "flex items-center w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors";
export const channelOptionsMenuItemIcon = "mr-3 flex-shrink-0 text-blue-500 dark:text-inherit [.text-red-500_&]:text-red-500 [.text-red-600_&]:text-red-600";
export const channelOptionsMenuItemLabel = "whitespace-nowrap";

// Стили для AddPostcardModal
export const fileDropZoneStyles = (isDragOver) => 
    `w-[316px] h-[158px] border-2 border-dashed flex items-center justify-center text-center text-sm cursor-pointer ${isDragOver ? "border-blue-500" : ""}`;

export const fileDropZoneTextStyles = "cursor-pointer block";

export const allowedFormatsTextStyles = "text-xs text-gray-500 dark:text-gray-400 text-center mb-4";

export const errorMessageStyles = "border border-red-500 dark:border-red-500 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400 p-3 rounded-md mb-3 text-xs whitespace-pre-line";

export const warningMessageStyles = "border border-yellow-500 dark:border-yellow-500 bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 p-3 rounded-md mb-3 text-xs whitespace-pre-line";

export const mediaContainerStyles = "my-5";

export const mediaLoadingContainerStyles = "flex justify-center items-center h-[316px]";

export const mediaStyles = (mediaLoaded) => `mx-auto max-h-64 object-contain ${mediaLoaded ? "" : "hidden"}`;

// Стили для кнопок меню
export const menuButton =
    "w-full flex items-center gap-4 text-inherit text-left py-4 px-6 transition-colors hover:bg-gray-100 dark:hover:bg-gray-600";

export const menuButtonActive =
    "w-full flex items-center gap-4 text-inherit text-left py-4 px-6 transition-colors bg-gray-100 dark:bg-gray-600";

export const menuButtonInactive =
    "w-full flex items-center gap-4 text-inherit text-left py-4 px-6 transition-colors text-gray-500 dark:text-gray-400";

// Стили для контейнера меню
export const menuContainer =
    "fixed top-0 left-0 h-full w-64 bg-white/80 dark:bg-gray-800/90 backdrop-blur-lg p-0 z-[99999] transform transition-transform duration-300 ease-in-out text-black dark:text-white";

export const menuOverlay =
    "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40";

export const menuHeader =
    "flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700";

export const menuTitle =
    "text-lg font-semibold text-gray-900 dark:text-gray-200";

export const menuCloseButton =
    "p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200";

export const menuContent =
    "p-4 space-y-2";

export const menuFooter =
    "p-4 border-t border-gray-200 dark:border-gray-700";

export const groupCategoryButtonStyles =
    "text-sm font-semibold px-3 py-2 rounded-md min-w-[100px] flex-shrink-0 transition-colors text-blue-444 dark:text-blue-300 " +
    "hover:bg-blue-500 hover:text-white dark:hover:bg-blue-400 dark:hover:text-white ";
